import api from "./api";

export interface Department {
  id: string;
  name: string;
  code: string;
  description: string | null;
  isActive: boolean;
}

export interface Team {
  id: string;
  name: string;
  departmentId: string;
  description: string | null;
  leaderId: string | null;
  isActive: boolean;
}

export interface DepartmentMember {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  employeeId: string;
  position: string | null;
  role: string;
  status: string;
}

export interface DepartmentsResponse {
  departments: Department[];
  total: number;
}

export interface TeamsResponse {
  department: {
    id: string;
    name: string;
  };
  teams: Team[];
  total: number;
}

export interface MembersResponse {
  department: {
    id: string;
    name: string;
  };
  members: DepartmentMember[];
  total: number;
}

export class DepartmentsService {
  /**
   * Get all departments
   */
  async getDepartments(): Promise<DepartmentsResponse> {
    console.log("🔍 Fetching departments from API...");
    try {
      const response = await api.get<{ data: DepartmentsResponse }>(
        "/api/v1/departments",
      );
      console.log("✅ Departments fetched successfully:", response.data);
      return response.data.data;
    } catch (error) {
      console.error("❌ Failed to fetch departments:", error);
      throw error;
    }
  }

  /**
   * Get department by ID
   */
  async getDepartment(id: string): Promise<Department> {
    const response = await api.get<{ data: { department: Department } }>(
      `/api/v1/departments/${id}`,
    );
    return response.data.data.department;
  }

  /**
   * Get teams in a department
   */
  async getDepartmentTeams(departmentId: string): Promise<TeamsResponse> {
    const response = await api.get<{ data: TeamsResponse }>(
      `/api/v1/departments/${departmentId}/teams`,
    );
    return response.data.data;
  }

  /**
   * Get members in a department
   */
  async getDepartmentMembers(departmentId: string): Promise<MembersResponse> {
    const response = await api.get<{ data: MembersResponse }>(
      `/api/v1/departments/${departmentId}/members`,
    );
    return response.data.data;
  }
}

export const departmentsService = new DepartmentsService();
export default departmentsService;
